export default {
  hero: {
    img: {
      url: "https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_leprechaun_strategiez.png",
      alt: "Nome da extensão",
    },
    title: "Leprechaun Strategiez Automações",
    text: [
      "A Leprechaun trabalha com robôs de investimentos desde 2018. Ao longo dos anos desenvolvemos estratégias operacionais para diversos perfis de investidores. Buscamos sempre um risco e retorno equilibrado em cada automação, o que se reflete no retorno de nossos robôs. ",
    ],
    testimonial: {
      text: "Solidez, retorno e longo prazo!",
      author: {
        name: "Jonas Neves – Sócio e estrategista da Leprechaun",
        // picture: "https://i.pravatar.cc/150?img=70",
      },
    },
  },
  stats: {
    title: "Principais números da Leprechaun",
    subtitle: "Mais de 15 anos de experiência em renda variável e 8 anos exclusivos dedicados a automação.",
    data: [
      {
        value: "+15",
        description: "Anos de experiência",
      },
      {
        value: "+8",
        description: "Anos operando com robôs ",
      },
      {
        value: "+200",
        description: "Estratégias programadas",
      },
    ],
  },
  features: {
    title: "Por que utilizar os robôs da Leprechaun Strategiez",
    subtitle: "Veja quais as principais vantagens dos robôs da Leprechaun Strategiez",
    data: [
      {
        title: "30 dias para testar",
      },
      {
        title: "100% automatizado",
      },
      {
        title: "Suporte Técnico",
      },
      {
        title: "Pool de Estratégias",
        description: "Contamos com um banco de estratégias operacionais diferente a disposição dos assinantes.",
      },
      {
        title: "Zero Emocional",
      },
      {
        title: "Execução Rápida",
      },
    ],
  },
  cta: {
    title: "Comece agora a investir com a Leprechaun!",
    subtitle: "Clique no botão e invista com as melhores automações.",
  },
  about: {
    title: "Sobre o desenvolvedor",
    subtitle: "A Leprechaun Strategiez",
    col1: [
      "A Leprechaun Strategiez surgiu de uma necessidade pessoal do seu sócio (Jonas Neves) e veio a se tornar uma importante casa de automações de robôs para investimentos.",
    ],
    col2: [
      "Jonas Neves iniciou sua jornada nos investimentos em 2003 e em 2016 começou a estudar e trabalhar com robôs. Em 2019 surgiu a Leprechaun e desde então já foram desenvolvidas mais de 200 estratégias operacionais diferentes.  ",
    ],
  },
  plans: {
    title: "Planos",
    subtitle: "Conheça os planos da extensão Placeholder IA",
  },
  strategies: {
    title: "Leprechaun Strategiez Automações",
    heading: "Estratégias operacionais prontas a sua disposição!",
    subtitle: "Diversifique suas operações com as melhores automações em robôs de investimentos.",
  },
  testimonials: [
    {
      text: "Utilizo os robôs da Leprechaun desde 2020 e as automações são incríveis, sempre superando as expectativas. O atendimento é top e o programador sempre aceita críticas e retorna sobre eventuais dúvidas. Estou totalmente satisfeito.",
      author: "Ernani Cardoso",
      job: "Aposentado",
      // image_url: "https://avatars.githubusercontent.com/u/97165289",
    },
    {
      text: "s estratégias da Leprechaun são excelentes. Como tudo, depende de gestão e paciência. Utilizo as estratégias desde 2022 e recomendo. O atendimento é ótimo. ",
      author: "Guilherme Fantozzi",
      job: "Trader",
      // image_url: "https://avatars.githubusercontent.com/u/97165289",
    },
    {
      text: "A Leprechaun atua com seriedade e tem um ótimo atendimento. Utilizo as estratégias há 2 anos. Além disso, estão sempre criando estratégias novas, o que proporciona aos clientes alternativas e diversificação.",
      author: "Roberto Vaver",
      job: "Empresário",
    },
  ],
};
